<template>
  <div>Google Oauth Redirect</div>
</template>
<script>
import qs from "query-string";

export default {
  mounted() {
    const params = qs.parse(window.location.search);

    window.opener &&
      window.opener.postMessage(
        { code: params.code, from: "Google" },
        window.location.origin
      );
  }
};
</script>
<style lang="scss" scoped>
</style>
